"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatFileRoutes = void 0;
var ChatFileRoutes;
(function (ChatFileRoutes) {
    ChatFileRoutes["BasePrefix"] = "chat-files";
    ChatFileRoutes["ById"] = ":chatFileId";
    ChatFileRoutes["AllByChatId"] = "all/:chatId";
    ChatFileRoutes["AllByClientId"] = "all-files/:clientId";
})(ChatFileRoutes = exports.ChatFileRoutes || (exports.ChatFileRoutes = {}));
